import { render } from "./ImageZoomOverlay.vue?vue&type=template&id=85c4b79c&ts=true"
import script from "./ImageZoomOverlay.ts?vue&type=script&lang=ts&external"
export * from "./ImageZoomOverlay.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__